import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownCharterServices', request)
}

async function post(request) {
    return await postMethod('/api/ownCharterServices', request)
}

async function put(request) {
    return await putMethod('/api/ownCharterServices', request)
}

export {get, post, put}
